import { hardButtonClassName } from "./styles";

type HardButtonProps = {
  children: React.ReactNode;
} & React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;

export function HardButton({
  children,
  className = '',
  ...props
}: HardButtonProps) {
  return (
    <button className={hardButtonClassName + className} {...props}>
      {children}
    </button>
  );
}
